import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { flex } from '../../../styles/utilities/flex';
import LCFormFieldTitle from './LCFormFieldTitle';

const StWrapper = styled.div.attrs({ 'data-displayname': 'LCFormField' })`
    ${flex('column')};
    justify-content: center;
    min-height: 50px;
    width: 100%;
`;

const StValue = styled.div`
    font-size: 15px;
`;

const StLCFormFieldTitle = styled(LCFormFieldTitle).attrs({ 'data-displayname': 'LCFormField__StLCFormFieldTitle' })`
    margin-bottom: 10px;
`;

interface Props {
    title?: string;
    tooltipText?: string;
    isEdit: boolean;
    mandatory?: boolean;
    className?: string;
}
export const LCFormField: FC<PropsWithChildren<Props>> = ({
    className,
    isEdit,
    mandatory,
    title,
    tooltipText,
    children
}) => {
    return (
        <StWrapper className={className}>
            {title ? (
                <StLCFormFieldTitle text={title} editable={isEdit} mandatory={mandatory} tooltipText={tooltipText} />
            ) : null}
            <StValue>{children}</StValue>
        </StWrapper>
    );
};
